import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {AuthenticationService} from '../_shared/services/authentication.service';
import {environment} from '../../environments/environment';
/**
 * Created by cate on 03-11-17.
 */

@Injectable()
export class LiningAndCoveringService {

    private liningsUrl = `${environment.apiUrl}/lining/`;
    private coveringsUrl = `${environment.apiUrl}/covering/`;

    constructor(private http: Http, private authService: AuthenticationService) {

    }

    getCoverings() {
        return this.http.get(this.coveringsUrl, this.authService.getAuthOptions()).map(res => res.json());
    }

    getLinings() {
        return this.http.get(this.liningsUrl, this.authService.getAuthOptions()).map(res => res.json());
    }

}


// WEBPACK FOOTER //
// ./src/app/project/lining-and-covering.service.ts